import React, { useMemo, useCallback, useState } from "react";


export const PORTFOLIO_TYPES = {
    b: "Block", s: "Sleeve", m: "Model", mm: "Model of Models"
}

const usePortfolios = (portfolioList)=>{

    const [ portfolios ] = useState(portfolioList);
    const [ portfolioTypes ] = useState( {
        b: "Block", s: "Sleeve", m: "Model", mm: "Model of Models"
    });

    // Check if the portfolios list is empty
    const isEmpty = useMemo(()=>{
        return !portfolios || !Array.isArray(portfolios) || portfolios.length === 0;
    }, [portfolios]);

    const countPortfoliosWithSignals = useCallback(()=>{
        let count = 0;
        if (!isEmpty) return count;

        portfolios.forEach(record=>{
            if (record?._user?.last_update || 0 > record?._user?.last_ack){
                count++;
            }
        });
        return count;
    }, [portfolios]);


    return {
        countPortfoliosWithSignals,
        portfolioTypes
    }
}
export default usePortfolios;
